import { ref, get, set } from 'firebase/database';
import { db } from '../Config/firebase';

export const isUsernameAvailable = async (username, currentUserId = null) => {
  try {
    const usersRef = ref(db, 'users');
    const snapshot = await get(usersRef);
    
    if (snapshot.exists()) {
      const users = snapshot.val();
      return !Object.entries(users).some(([uid, userData]) => {
        if (currentUserId && uid === currentUserId) return false;
        return userData.username?.toLowerCase() === username.toLowerCase();
      });
    }
    return true;
  } catch (error) {
    console.error('Error checking username:', error);
    throw error;
  }
};

export const handleSocialAuth = async (user, provider) => {
  let username = user.displayName || user.email.split('@')[0];
  let counter = 1;
  
  while (!(await isUsernameAvailable(username))) {
    username = `${user.displayName || user.email.split('@')[0]}${counter}`;
    counter++;
  }

  await set(ref(db, 'users/' + user.uid), {
    email: user.email || `${user.uid}@${provider}.com`,
    username: username,
    joinDate: new Date().toISOString()
  });

  return {
    uid: user.uid,
    email: user.email || `${user.uid}@${provider}.com`,
    username: username
  };
};